<template>
  <j-modal :title="title" v-dragModal :width="800" :visible="visible" :confirmLoading="confirmLoading"
    :maskClosable="false" :body-style="{ height: '480px', overflow: 'hidden', overflowY: 'scroll' }" @ok="handleOk"
    @cancel="handleCancel" :okText="$t('确定')" :cancelText="$t('关闭')" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
    <a-spin :spinning="confirmLoading">
      <j-form-container>
        <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-model-item :label="$t('处理人姓名')" prop="complaintsProcessors">
                <a-input v-model="model.complaintsProcessors"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('处理人联系方式')" prop="complaintsProcessorsPhone">
                <a-input v-model="model.complaintsProcessorsPhone"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('是否已解决')" prop="isResolved">
                <a-radio-group v-model="model.isResolved">
                  <a-radio :value="0">{{ $t('已解决') }}</a-radio>
                  <a-radio :value="1">{{ $t('未解决') }}</a-radio>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :label="$t('处理描述')" prop="complaintsResponse">
                <a-textarea v-model="model.complaintsResponse" :placeholder="$t('请输入处理描述')" :rows="4" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </j-form-container>
    </a-spin>
  </j-modal>
</template>

<script>
  import {
    JeecgListMixin
  } from '@/mixins/JeecgListMixin';
  import {
    httpAction,
    getAction,
    postAction
  } from '@/api/manage'
  import {
    validateDuplicateValue
  } from '@/utils/util'
  import {PhoneNumberPattern} from '@/utils/regPattern'
  export default {
    mixins: [JeecgListMixin],
    name: 'handleModal',
    components: {},
    data() {
      return {
        title: '',
        width: 800,
        visible: false,
        disableSubmit: false,
        confirmLoading: false,
        model: {},
        url: {
          dealingWithState: "/jeecg-charge/oa/userComplaints/dealingWithState",
          queryById: "/jeecg-charge/oa/userComplaints/queryById",
          list: "null",
        },
      }
    },
    computed: {
      validatorRules() {
        return {
          complaintsProcessors: [{
            required: true,
            message: this.$t('请输入处理人姓名'),
            trigger: 'blur'
          }],
          complaintsProcessorsPhone: [{
            required: true,
            message: this.$t('请输入处理人联系方式'),
            trigger: 'blur'
          },{pattern: PhoneNumberPattern,message: this.$t('请输入正确的手机号码')}],
          complaintsResponse: [{
            required: true,
            message: this.$t('请输入处理描述'),
            trigger: 'blur'
          }],
          isResolved: [{
            required: true,
            message: this.$t('请选择是否解决'),
            trigger: 'change'
          }],
        }
      },
    },
    methods: {
      init(row){
        this.visible = true;
        this.title = this.$t('处理');
        this.model = JSON.parse(JSON.stringify(row));
      },
      close() {
        this.$emit('close');
        this.visible = false;
      },
      handleOk() {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            postAction(this.url.dealingWithState, this.model).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
                this.visible = false;
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
      handleCancel() {
        this.close()
      },
    }
  }
</script>